<template>
    <div class="promocode-field">
        <form class="form_call"  @submit.prevent="sendData">
            <div class="form-in" v-if="formVisible">
                <div class="form-group form-phone" @focusin="handleFocus" @focusout="handleBlur">
                    <label :class="{ 'label-highlight': isFocused, 'label-highlight' :  code != ''}" for="code">{{dictionaryLang.promocodePage.promocode_form.label}}</label>
                    <masked-input v-model="code" mask="####-####" placeholder="" autocomplete="off" class="form-control" name="code" v-validate="{ required: true, regex: regexRules.code }" data-vv-delay="1000" :class="{'erorr-input' : errors.has('code')}"/>
                </div>
                <div class="btn-send">
                    <button class="btn btn-submit btn-success" type="button" @click="sendData" :disabled="errors.any()">
                        <div class="bg-img" :style="'background-image:url(' + btnCodeBg + ')'"></div>
                        <div class="bg-img-hover" :style="'background-image:url(' + btnCodeBgHover + ')'"></div>
                        <span>{{ dictionaryLang.promocodePage.promocode_form.btn }}</span>
                    </button>
                    <span class="error-message" v-show="errors.has('code')" v-if="globalLang == 'ru'">Введите промокод</span>
                    <span class="error-message" v-show="errors.has('code')" v-if="globalLang == 'kz'">Жарнамалық кодты енгізіңіз</span>
                </div> 
                <div class="error-code-msg error-code" v-if="error_code">{{ dictionaryLang.promocodePage.promocode_form.error_code }}</div>
                <div class="error-code-msg error-code-activate" v-if="error_code_is_active">{{ dictionaryLang.promocodePage.promocode_form.error_code_is_active }}</div>
                <div class="error-code-msg error-code-activate" v-if="errorMaxCodeUpload">{{ dictionaryLang.promocodePage.promocode_form.errorMaxCodesUploads }}</div>
            </div>
            <!-- <div class="successMessage" v-if="!formVisible">
                <h3>Спасибо, ваши контакты внесены в базу потенциальных клиентов. Ожидайте старта продаж!</h3>
            </div> -->
        </form>
    </div>
</template>

<script>
    import MaskedInput from 'vue-masked-input'
    import {mapGetters} from 'vuex'
    import { Validator } from 'vee-validate';
    import { collection, doc, setDoc, getDoc, getDocs, updateDoc, arrayUnion } from "firebase/firestore"; 
    const moment = require('moment')
    // import svgIcon from '@/components/partials/SvgIcon.vue';
    export default {
        name: 'FormSignUpProject',
        props: ['options'],
        data () {
            return {
                btnCodeBg: require('@/assets/images/btn-code-reg-bg.png'),
                btnCodeBgHover: require('@/assets/images/btn-code-reg-bg-hover.png'),
// ......................................................................
                code: '',
                globalLang: window.GlobalLang, 
                formVisible: true,
                isFocused: false,
                errorMsg: false,
                error_code: false,
                error_code_is_active: false,
                errorMaxCodeUpload: false,
                regexRules: {
                    code: /^[A-Z0-9]{4}-[A-Z0-9]{4}$/,
                    phone: /^((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{10,10}$/,
                }
            }
        },
        components: {
            MaskedInput,
            // svgIcon,
        },
        computed: mapGetters({
            dictionaryLang: 'loadDictionaryLang',
            userData: 'loadUserDataStore',
        }),
        methods: {
            sendData() {
                var _self = this;
                // var querystring = require('querystring');
                // var data = {
                //     'admin': this.form.email_admin,
                //     'name': this.name,
                //     'phone': this.phone,
                //     'project_name': this.options[0].project_name,
                //     'page': 'Жилые комплексы',
                // };
                // console.log(data, 'form project signup')
                // // console.log(JSON.stringify(data));
                this.$validator.validate().then(async result => {
                    if(result) {
                        var _self = this;
                        this.error_code = false;
                        this.error_code_is_active = false;
                        const currentDate = this.generateCurrentDate();
                        const code = this.code.replace(/-/g, '');
                        const docRef = doc(this.$db, "codes", code);
                        const userRef = doc(this.$db, "users", this.userData.user.ID);
                        const docSnap = await getDoc(docRef);
                        const userSnap = await getDoc(userRef);
                        if (userSnap.exists()) {
                            const userArr = userSnap.data();
                            if (userArr.codes != null) {
                                if (userArr.codes.length >= 30) {
                                    this.errorMaxCodeUpload = true;
                                } else {
                                    addCodeToDB();
                                    updateUserLangDB();
                                }
                            } else {
                                updateUserDB();
                                updateUserLangDB();
                                addCodeToDB();
                            }
                        } else {
                            this.error_code = true;
                            this.code = '';
                            console.log("No such user found!");
                        }

                        async function addCodeToDB() {
                            if (docSnap.exists()) {
                                const arrCode = docSnap.data();
                                console.log("Document data:", docSnap.data());
                                if (arrCode.activate) {
                                    _self.error_code_is_active = true;
                                    _self.code = '';
                                } else {
                                    await updateDoc(docRef, {
                                        activate: true,
                                        activate_date: currentDate,
                                        userID: _self.userData.user.ID,
                                    });
                                    await updateDoc(userRef, {
                                        codes: arrayUnion(code)
                                    });
                                    _self.code = '';
                                    _self.$modal.show('modal-promocode-agree');
                                    _self.$store.dispatch('getUserData', _self.userData.user.ID);
                                    console.log('CODE IS ACTIVATED');
                                }
                            } else {
                                _self.error_code = true;
                                _self.code = '';
                                // docSnap.data() will be undefined in this case
                                console.log("No such document!");
                            }
                        }

                        async function updateUserDB() {
                            if (userSnap.exists()) {
                                console.log(userSnap.data());
                                if (userSnap.data().codes == null) {
                                    await updateDoc(userRef, {
                                        'user.online_test' : false,
                                        'user.online_test_invite' : false,
                                    });
                                } else {
                                    console.log('false')
                                }
                            } else {
                                console.log("No such USER DB!");
                            }
                        }

                        async function updateUserLangDB() {
                            if (userSnap.exists()) {
                                console.log(userSnap.data());
                                await updateDoc(userRef, {
                                    'user.lang' : _self.globalLang,
                                });
                            } else {
                                console.log("No such USER DB!");
                            }
                        }
                    } else {
                        this.errorMsg = true;
                        console.log('Form inputs with errors');
                    }
                });
            },

            generateCurrentDate() {
                const currentDate = new Date();
                const day = String(currentDate.getDate()).padStart(2, '0');
                const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Месяцы начинаются с 0
                const year = currentDate.getFullYear();
                const formattedDate = `${year}-${month}-${day}`;
                return formattedDate;
            },
            handleFocus() {
                this.isFocused = true;
            },
            handleBlur() {
                this.isFocused = false;
            }
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/components/promocode-page/promocode-field.scss';
    @import '@/styles/components/promocode-page/respond/promocode-field-respond.scss';
</style>